import {
  regex
} from 'vuelidate/lib/validators/common';
import {
  bankAccountNumberRegex
} from '@/constants';

export default regex('bankAccountNumber', bankAccountNumberRegex);